// Widget-Plugin: Subdashboard
var vcDashboardPopup = (function ($) {

    function formatNumber(raw) {
        if (raw === null || raw === undefined) return "--";
        if (!raw && raw !== 0) return "--";
        var parts = raw.toString().split(".");
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        return parts.length > 1 ? parts[0] + "," + parts[1] : parts[0];
    }

    function addSettingsButton($item, onClick) {
        var $settingsBtn = $("<div class='dashboard-settings-btn'><i class='fa-solid fa-gear color-font-secondary'></i></div>");
        $item.append($settingsBtn);
        $settingsBtn.on("click", function (e) {
            e.stopPropagation();
            onClick(e);
        });
        return $settingsBtn;
    }

    function open(options) {
        var title = options.title || vcDashboardResources.get("settings");
        var currentSettings = options.settings || {};
        var fields = options.fields || [];
        var onSave = options.onSave || function () { };

        var layout = options.layout || "single";
        var $overlay = $("<div class='dashboard-settings-overlay'></div>");
        var $popup = $("<div class='dashboard-settings-popup'></div>");
        if (layout === "twocolumn") $popup.addClass("dashboard-settings-popup--twocolumn");
        var $title = $("<div class='dashboard-settings-popup-title'>" + title + "</div>");
        var $form = $("<div class='dashboard-settings-popup-form'></div>");
        var $formLeft, $formRight;
        if (layout === "twocolumn") {
            $form.addClass("dashboard-settings-popup-form--twocolumn");
            $formLeft = $("<div class='dashboard-settings-popup-form-col dashboard-settings-popup-form-col--left'></div>");
            $formRight = $("<div class='dashboard-settings-popup-form-col dashboard-settings-popup-form-col--right'></div>");
            $form.append($formLeft, $formRight);
        }

        var fieldElements = [];

        $.each(fields, function (i, fieldDef) {
            var $row = $("<div class='dashboard-settings-popup-row'></div>").attr("data-field-index", i);
            var $label = $("<label class='dashboard-settings-popup-label'></label>").text(fieldDef.label != null ? fieldDef.label : fieldDef.key);
            var val = currentSettings[fieldDef.key];
            if (fieldDef.arrayIndex !== undefined && Array.isArray(val)) {
                val = val[fieldDef.arrayIndex] !== undefined ? val[fieldDef.arrayIndex] : null;
            }

            if (fieldDef.type === "searchselect") {
                var $searchWrapper = $("<div class='dashboard-searchselect-wrapper'></div>").css({ position: "relative", width: "100%" });
                var $hiddenInput = $("<input type='hidden'>").attr("data-key", fieldDef.key).attr("data-array-index", fieldDef.arrayIndex !== undefined ? fieldDef.arrayIndex : "").val(val || "");
                var $searchInput = $("<input class='dashboard-settings-popup-input dashboard-searchselect-input' type='text'>").attr({ placeholder: vcDashboardResources.get("search"), autocomplete: "off" }).css({ width: "100%", boxSizing: "border-box" });
                var $dropdown = $("<div class='dashboard-searchselect-dropdown'></div>").css({
                    position: "absolute", top: "100%", left: 0, right: 0, maxHeight: "200px",
                    overflowY: "auto", background: "#fff", border: "1px solid #555",
                    borderRadius: "4px", zIndex: 1000, display: "none", boxShadow: "0 4px 12px rgba(0,0,0,0.4)"
                });

                var allOpts = fieldDef.options || [];
                // ensure a value is always selected
                var initialVal = val;
                if ((initialVal == null || initialVal === "") && allOpts.length > 0) {
                    initialVal = allOpts[0].value;
                }
                $hiddenInput.val(initialVal || "");
                $.each(allOpts, function (j, opt) {
                    if (opt.value == initialVal) { $searchInput.val(opt.text); return false; }
                });

                function renderSearchOptions(filter) {
                    $dropdown.empty();
                    var lowerFilter = (filter || "").toLowerCase();
                    var count = 0;
                    $.each(allOpts, function (j, opt) {
                        if (lowerFilter && opt.text.toLowerCase().indexOf(lowerFilter) === -1) return;
                        count++;
                        var isSelected = opt.value == $hiddenInput.val();
                        var $optDiv = $("<div class='dashboard-searchselect-option'></div>")
                            .text(opt.text)
                            .attr("data-value", opt.value)
                            .css({ padding: "6px 10px", cursor: "pointer", fontWeight: isSelected ? "bold" : "normal" });
                        $optDiv.on("mousedown", function (e) {
                            e.preventDefault();
                            $hiddenInput.val(opt.value);
                            $searchInput.val(opt.text);
                            $dropdown.hide();
                        });
                        $optDiv.on("mouseenter", function () { $(this).css("background", "var(--color-bg-hover, rgba(255,255,255,0.1))"); });
                        $optDiv.on("mouseleave", function () { $(this).css("background", ""); });
                        $dropdown.append($optDiv);
                    });
                    $dropdown.toggle(count > 0);
                }

                var $clearBtn = $("<div class='dashboard-searchselect-clear'><i class='fa-solid fa-xmark'></i></div>").css({
                    position: "absolute", right: "8px", top: "50%", transform: "translateY(-50%)",
                    cursor: "pointer", display: "block", zIndex: 1, color: "#888", fontSize: "14px"
                });
                $clearBtn.on("mousedown", function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    $searchInput.val("");
                    renderSearchOptions("");
                    $searchInput.focus();
                });

                $searchInput.on("focus", function () { renderSearchOptions($(this).val()); });
                $searchInput.on("input", function () {
                    renderSearchOptions($(this).val());
                });
                $searchInput.on("blur", function () {
                    setTimeout(function () {
                        $dropdown.hide();
                        // restore display text of current selection
                        var currentVal = $hiddenInput.val();
                        var foundText = "";
                        $.each(allOpts, function (j, opt) {
                            if (opt.value == currentVal) { foundText = opt.text; return false; }
                        });
                        $searchInput.val(foundText);
                    }, 150);
                });
                $searchInput.css("paddingRight", "28px");

                $searchWrapper.append($hiddenInput, $searchInput, $clearBtn, $dropdown);
                $row.append($label, $searchWrapper);
                fieldElements.push($hiddenInput);
            } else if (fieldDef.type === "select") {
                var $select = $("<select class='dashboard-settings-popup-input'></select>").attr("data-key", fieldDef.key);
                $.each(fieldDef.options || [], function (j, opt) {
                    var $opt = $("<option></option>").val(opt.value).text(opt.text);
                    if (opt.value == val) $opt.attr("selected", "selected");
                    $select.append($opt);
                });
                $row.append($label, $select);
                fieldElements.push($select);
            } else if (fieldDef.type === "checkbox") {
                var $checkbox = $("<input type='checkbox' class='dashboard-settings-popup-checkbox'>").attr("data-key", fieldDef.key);
                if (val) $checkbox.prop("checked", true);
                $row.addClass("dashboard-settings-popup-row--inline");
                $row.append($checkbox, $label);
                fieldElements.push($checkbox);
            } else if (fieldDef.type === "number") {
                var $input = $("<input class='dashboard-settings-popup-input'>").attr("type", "number").attr("data-key", fieldDef.key).val(val != null ? val : "").css({ width: "60px", textAlign: "right" });
                if (fieldDef.inline) {
                    $row.addClass("dashboard-settings-popup-row--inline");
                }
                $row.append($label, $input);
                if (fieldDef.suffix) $row.append($("<span class='dashboard-settings-popup-suffix'></span>").text(fieldDef.suffix).css({ marginLeft: "6px" }));
                fieldElements.push($input);
            } else if (fieldDef.type === "signallist") {
                var allOpts = fieldDef.options || [];
                var currentArr = Array.isArray(currentSettings[fieldDef.key]) ? currentSettings[fieldDef.key] : [];
                if (currentArr.length === 0 && allOpts.length > 0) currentArr = [allOpts[0].value];
                var $listContainer = $("<div class='dashboard-signallist-container'></div>").attr("data-key", fieldDef.key).attr("data-field-type", "signallist");

                function createSignalEntry(selectedVal, removable) {
                    var $entry = $("<div class='dashboard-signallist-entry'></div>").css({ position: "relative", display: "flex", alignItems: "center", gap: "4px", marginBottom: "4px" });
                    var $sw = $("<div class='dashboard-searchselect-wrapper'></div>").css({ position: "relative", flex: 1 });
                    var $hi = $("<input type='hidden'>").val(selectedVal || "");
                    var $si = $("<input class='dashboard-settings-popup-input dashboard-searchselect-input' type='text'>").attr({ placeholder: vcDashboardResources.get("search"), autocomplete: "off" }).css({ width: "100%", boxSizing: "border-box", paddingRight: "28px" });
                    var $dd = $("<div class='dashboard-searchselect-dropdown'></div>").css({ position: "absolute", top: "100%", left: 0, right: 0, maxHeight: "200px", overflowY: "auto", background: "#fff", border: "1px solid #555", borderRadius: "4px", zIndex: 1000, display: "none", boxShadow: "0 4px 12px rgba(0,0,0,0.4)" });
                    var initVal = selectedVal;
                    if ((initVal == null || initVal === "") && allOpts.length > 0) initVal = allOpts[0].value;
                    $hi.val(initVal || "");
                    $.each(allOpts, function (j, opt) { if (opt.value == initVal) { $si.val(opt.text); return false; } });
                    function renderOpts(filter) {
                        $dd.empty();
                        var lf = (filter || "").toLowerCase(); var count = 0;
                        $.each(allOpts, function (j, opt) {
                            if (lf && opt.text.toLowerCase().indexOf(lf) === -1) return;
                            count++;
                            var isSel = opt.value == $hi.val();
                            var $o = $("<div class='dashboard-searchselect-option'></div>").text(opt.text).attr("data-value", opt.value).css({ padding: "6px 10px", cursor: "pointer", fontWeight: isSel ? "bold" : "normal" });
                            $o.on("mousedown", function (e) { e.preventDefault(); $hi.val(opt.value); $si.val(opt.text); $dd.hide(); });
                            $o.on("mouseenter", function () { $(this).css("background", "var(--color-bg-hover, rgba(255,255,255,0.1))"); });
                            $o.on("mouseleave", function () { $(this).css("background", ""); });
                            $dd.append($o);
                        });
                        $dd.toggle(count > 0);
                    }
                    var $cb = $("<div class='dashboard-searchselect-clear'><i class='fa-solid fa-xmark'></i></div>").css({ position: "absolute", right: "8px", top: "50%", transform: "translateY(-50%)", cursor: "pointer", zIndex: 1, color: "#888", fontSize: "14px" });
                    $cb.on("mousedown", function (e) { e.preventDefault(); e.stopPropagation(); $si.val(""); renderOpts(""); $si.focus(); });
                    $si.on("focus", function () { renderOpts($(this).val()); });
                    $si.on("input", function () { renderOpts($(this).val()); });
                    $si.on("blur", function () { setTimeout(function () { $dd.hide(); var cv = $hi.val(); var ft = ""; $.each(allOpts, function (j, opt) { if (opt.value == cv) { ft = opt.text; return false; } }); $si.val(ft); }, 150); });
                    $sw.append($hi, $si, $cb, $dd);
                    $entry.append($sw);
                    if (removable) {
                        var $removeBtn = $("<div class='dashboard-signallist-remove'><i class='fa-solid fa-trash'></i></div>").css({ cursor: "pointer", color: "#c00", fontSize: "12px", padding: "4px" });
                        $removeBtn.on("click", function () { $entry.remove(); });
                        $entry.append($removeBtn);
                    }
                    return $entry;
                }

                $.each(currentArr, function (idx, sigVal) {
                    $listContainer.append(createSignalEntry(sigVal, idx > 0));
                });

                var $addBtn = $("<button type='button' class='dashboard-signallist-add'><i class='fa-solid fa-plus'></i> " + vcDashboardResources.get("add") + "</button>").css({ marginTop: "4px", fontSize: "11px", cursor: "pointer", padding: "3px 8px", border: "1px solid #ccc", borderRadius: "3px", background: "#f5f5f5" });
                $addBtn.on("click", function () {
                    $listContainer.find(".dashboard-signallist-add").before(createSignalEntry(null, true));
                });
                $listContainer.append($addBtn);
                $row.append($label, $listContainer);
                fieldElements.push($listContainer);
            } else {
                var $input = $("<input class='dashboard-settings-popup-input'>").attr("data-key", fieldDef.key).val(val);
                $row.append($label, $input);
                fieldElements.push($input);
            }

            if (fieldDef.breakBefore) {
                $row.css("marginTop", "12px");
            }
            if (fieldDef.breakAfter) {
                $row.css({ paddingBottom: "8px", borderBottom: "1px solid #e0e0e0" });
            }

            if (layout === "twocolumn" && fieldDef.column === "right") {
                $formRight.append($row);
            } else if (layout === "twocolumn") {
                $formLeft.append($row);
            } else {
                $form.append($row);
            }
        });

        // dependsOn: show/hide rows based on another field's value
        $.each(fields, function (i, fieldDef) {
            if (fieldDef.dependsOn) {
                var $depRow = $form.find(".dashboard-settings-popup-row[data-field-index='" + i + "']");
                var depKey = fieldDef.dependsOn.key;
                var depValue = fieldDef.dependsOn.value;
                var $source = $form.find("[data-key='" + depKey + "']");
                function toggleRow() {
                    var v = $source.val();
                    if (v !== "" && !isNaN(v)) v = parseFloat(v);
                    $depRow.toggle(v === depValue);
                }
                $source.on("change", toggleRow);
                toggleRow();
            }
        });

        var $buttons = $("<div class='dashboard-settings-popup-buttons'></div>");
        var $saveBtn = $("<button class='dashboard-settings-popup-save'>" + vcDashboardResources.get("save") + "</button>");
        var $cancelBtn = $("<button class='dashboard-settings-popup-cancel'>" + vcDashboardResources.get("cancel") + "</button>");
        $buttons.append($saveBtn, $cancelBtn);

        $popup.append($title, $form, $buttons);
        $overlay.append($popup);
        $("body").append($overlay);

        $cancelBtn.on("click", function () { $overlay.remove(); });
        $overlay.on("mousedown", function (ev) {
            if (!$popup[0].contains(ev.target)) $overlay.remove();
        });

        $saveBtn.on("click", function () {
            var newSettings = {};
            $.each(fieldElements, function (i, $field) {
                var key = $field.attr("data-key");
                var fieldType = $field.attr("data-field-type");
                var arrayIdx = $field.attr("data-array-index");
                if (fieldType === "signallist") {
                    var arr = [];
                    $field.find(".dashboard-signallist-entry input[type='hidden']").each(function () {
                        var v = $(this).val();
                        if (v !== "" && !isNaN(v)) v = parseFloat(v);
                        if (v !== "" && v != null) arr.push(v);
                    });
                    newSettings[key] = arr;
                } else if ($field.attr("type") === "checkbox") {
                    newSettings[key] = $field.prop("checked");
                } else if (arrayIdx !== undefined && arrayIdx !== "") {
                    var idx = parseInt(arrayIdx);
                    var val = $field.val();
                    if (val !== "" && !isNaN(val)) val = parseFloat(val);
                    if (!Array.isArray(newSettings[key])) newSettings[key] = currentSettings[key] ? currentSettings[key].slice() : [];
                    newSettings[key][idx] = val;
                } else {
                    var val = $field.val();
                    if (val !== "" && !isNaN(val)) val = parseFloat(val);
                    newSettings[key] = val;
                }
            });
            $overlay.remove();
            onSave(newSettings);
        });
    }

    function getSettings($item, defaults) {
        var currentSettings = {};
        try { currentSettings = JSON.parse($item.attr("data-settings") || "{}"); } catch (ex) { }
        return $.extend({}, defaults, currentSettings);
    }

    function getApi($item) {
        var $el = $item.closest(".vc-dashboard-wrapper").parent();
        return $el.data("vcDashboard");
    }

    function getSignalOptions($item) {
        var api = getApi($item);
        var signals = (api && api.getSignals) ? api.getSignals() : [];
        return $.map(signals, function (sig) {
            var id = sig.signalid || sig.id;
            var name = sig.Name || sig.name || "";
            var unit = sig.Unit || sig.dims || "";
            return { value: id, text: name + (unit ? " [" + unit + "]" : "") };
        });
    }

    function findSignal($item, signalId) {
        var api = getApi($item);
        var signals = (api && api.getSignals) ? api.getSignals() : [];
        var signal = null;
        if (signalId) {
            $.each(signals, function (i, sig) {
                var id = sig.signalid || sig.id;
                if (id == signalId) { signal = sig; return false; }
            });
        }
        return signal;
    }

    function initSettingsButton($item, plugin, buildFieldsFn, onAfterSave) {
        if (!plugin.defaults.showSettings) return;
        addSettingsButton($item, function () {
            var currentSettings = getSettings($item, plugin.settingsDefaults || {});
            var fields = buildFieldsFn.call(plugin, currentSettings, $item);

            open({
                title: plugin.popupTitle || vcDashboardResources.get("settings"),
                layout: plugin.popupLayout || "single",
                settings: currentSettings,
                fields: fields,
                onSave: function (newSettings) {
                    if (currentSettings.LoggerId) newSettings.LoggerId = currentSettings.LoggerId;
                    if (currentSettings.Day) newSettings.Day = currentSettings.Day;
                    $item.attr("data-settings", JSON.stringify(newSettings));
                    var api = getApi($item);
                    if (onAfterSave) onAfterSave.call(plugin, $item, newSettings, api);
                    if (api && api.saveConfig) api.saveConfig();
                }
            });
        });
    }

    function initPlugin($item, plugin, settings) {
        if (typeof plugin.onLoad === "function") {
            plugin.onLoad($item, settings);
        }
        if (typeof plugin.buildFields === "function" && typeof plugin.onSettingsSave === "function") {
            initSettingsButton($item, plugin, plugin.buildFields, plugin.onSettingsSave);
        }
    }

    function resolveEffectiveSettings($item, settings) {
        var effectiveSettings = $.extend({}, settings);
        effectiveSettings.DateUserDef = false;
        var api = getApi($item);
        var status = api ? api.getSettings().Status : null;

        if (effectiveSettings.Interval === 0) {


            var menuInterval = (status && status.menu) ? status.menu.interval : 1;
            switch (menuInterval) {
                case 3: effectiveSettings.Interval = 2; break;
                case 5: effectiveSettings.Interval = 3; break;
                default: effectiveSettings.Interval = 1; break;
            }
        }
        if (status && status.date && status.date.isSingle === false && status.date.dateRange) {
            effectiveSettings.StartDate = status.date.dateRange.from;
            effectiveSettings.EndDate = status.date.dateRange.to;
            effectiveSettings.DateUserDef = true;
        }
        return { effectiveSettings: effectiveSettings, status: status };
    }

    function buildChartParams(settings, status) {

       


        var signalIds = (settings.SignalIds && settings.SignalIds.length > 0) ? settings.SignalIds : [];
        var signalParam = { 'series': [] };
        $.each(signalIds, function (i, sigId) {
            signalParam.series.push({ bsaid: [sigId], rule: '[bsaid=' + sigId + ']', ruleType: 1, seriesType: settings.ChartType || 'spline' });
        });

        var today = new Date();
        var todayStr = today.getDate() + '.' + (today.getMonth() + 1) + '.' + today.getFullYear();

       
        var singleDate = status.date.singleDate || todayStr;
        var visualName = "";
        var dataType = 1;
        var dateUserDef = settings.DateUserDef;
        var interval = 1;
        var start, end;

        switch (settings.Interval) {
            case 0:
            case 1:
                visualName = "VISUAL_RAMP_SINGLE";
                dataType = 1;
                interval = 1;
                break;
            case 2:
                visualName = "VISUAL_RAMP_DAILY";
                dataType = 2;
                interval = 3;
                break;
            case 3:
                visualName = "VISUAL_RAMP_MONTHLY";
                dataType = 2;
                interval = 5;
                break;
            //default:
            //    visualName = "VISUAL_RAMP_SINGLE";
            //    dataType = 1;
            //    break;
        }
        

        if (settings.StartDate && settings.EndDate) {

            start = settings.StartDate;
            end = settings.EndDate;
        } else {
            var parts = singleDate.split('.');
            var day = parseInt(parts[0]);
            var month = parseInt(parts[1]);
            var year = parseInt(parts[2]);
            switch (settings.Interval) {
                case 2:
                    start = '1.' + month + '.' + year;
                    end = new Date(year, month, 0).getDate() + '.' + month + '.' + year;
                    break;
                case 3:
                    start = '1.1.' + year;
                    end = '31.12.' + year;
                    break;
                default:
                    start = singleDate;
                    end = singleDate;
                    break;
            }
        }

      


        //
        var param = {
            'loggerID': settings.LoggerId, 'ShowInvalidValues': true, 'ShowPlotLines': true, DateUserDef: dateUserDef, interval: interval, 'datatype': dataType, 'startDate': start, 'endDate': end, 'NoZoom': false, ShowExportIcons: false,
            'ShowEmptyChart': true, 'ShowUnsmoothedValues': true, 'HideNotAllowedIntervals': false, "ShowIntervention": true, 'UseSimpleBottomLegend': true, UseWidgetHeaderDate: false,
            'IsCumulated': settings.IsCumulated || false
        };

        var comparisonMode = settings.ComparisonMode || 0;
        switch (comparisonMode) {
            case 0:
                break;
            case 1:
                if (status && status.date) {
                    switch (status.date.dateComparisonType) {
                        case 0:
                            param.AutoComparisonInterval = parseInt(status.date.flexibleInterval);
                            
                            break;
                        case 1:
                            param.compareStartDate = status.date.dateRangeComparison.from;
                            param.compareEndDate = status.date.dateRangeComparison.to;
                            param.DateUserDef = true;
                            break;
                        case 2:
                            param.AutoPreviousPeriodComparison = true;
                            break;
                    }
                }
                break;
            case 2:
                param.AutoComparisonInterval = parseInt(settings.ComparisonOffset);
                break;
        }

        var priceCo2 = settings.PriceCo2 || 0;
        switch (priceCo2) {
            case 0:
                break;
            case 1:
                param.usePrices = true;
                break;
            case 2:
                param.useCo2 = true;
                break;
        }

        return { Param: param, SignalParam: signalParam, VisualName: visualName };
    }

    return {
        formatNumber: formatNumber,
        addSettingsButton: addSettingsButton,
        open: open,
        getSettings: getSettings,
        getApi: getApi,
        getSignalOptions: getSignalOptions,
        findSignal: findSignal,
        initSettingsButton: initSettingsButton,
        initPlugin: initPlugin,
        resolveEffectiveSettings: resolveEffectiveSettings,
        buildChartParams: buildChartParams
    };

})(jQuery);